import { render, staticRenderFns } from "./TextoVerMas.vue?vue&type=template&id=dc746908"
import script from "./TextoVerMas.vue?vue&type=script&lang=js"
export * from "./TextoVerMas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports